<template>
  <div class="inline-flex items-center gap-1 rounded-full px-2 font-medium text-white" :class="displayClasses">
    <font-awesome-icon :icon="icon" />
    <span>{{ label }}</span>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "IsOpenValue",
  computed: {
    isOpen() {
      return this.params.valueFormatted !== null && this.params.valueFormatted !== undefined
        ? this.params.valueFormatted
        : this.params.value;
    },
    displayClasses() {
      return this.isOpen
        ? "bg-gradient-to-br from-orange-300 to-orange-400"
        : "bg-gradient-to-br from-green-300 to-green-400";
    },
    icon() {
      return this.isOpen ? "exclamation-circle" : "check-circle";
    },
    label() {
      return this.isOpen ? "Has Open Job Cards" : "All Job Cards Closed";
    },
  },
});
</script>
